import * as React from "react";
import { SvgIcon, SvgIconProps } from "@material-ui/core"
import { forwardRef } from "react";


export const TelegramIcon: React.FC<SvgIconProps> = forwardRef(({...props}, ref) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 20" innerRef={ref} data-name="Twitter">
      <path d="M2.35593 8.82656C2.35593 8.82656 12.3559 4.72256 15.8241 3.27744C17.1536 2.69944 21.6622 0.849681 21.6622 0.849681C21.6622 0.849681 23.7432 0.040481 23.5698 2.00576C23.5119 2.81504 23.0495 5.64736 22.5871 8.71096C21.8934 13.0462 21.142 17.7861 21.142 17.7861C21.142 17.7861 21.0264 19.1156 20.0438 19.3468C19.0611 19.578 17.4426 18.5376 17.1536 18.3063C16.9223 18.133 12.8183 15.5318 11.3154 14.2601C10.9108 13.9133 10.4484 13.2197 11.3732 12.4104C13.4542 10.5029 15.9397 8.13296 17.4426 6.63008C18.1362 5.9364 18.8298 4.31792 15.9397 6.2832C11.8357 9.1156 7.78945 11.7746 7.78945 11.7746C7.78945 11.7746 6.86457 12.3526 5.13049 11.8323C3.39633 11.3122 1.37321 10.6185 1.37321 10.6185C1.37321 10.6185 -0.0139943 9.75144 2.35593 8.82656Z" fill="currentColor"/>
    </SvgIcon>
  );
})

export default TelegramIcon;